import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

// ---------Shared--------------------------------------------
import { StudentService } from '../../shared-components/student/student.service';
import { Student } from '../../shared-components/student/student.model';
import { YearService } from '../../shared-components/year/year.service';
import { AwardsService } from './awards.service';
import { Awards } from './awards.model';

// -------Angular Material------------------------------------
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { AriaDirective } from '../../shared-components/directives/aria.directive';
import { MatSort } from '@angular/material/sort';

@AutoUnsubscribe()
@Component({
    selector: 'app-awards',
    templateUrl: './awards.component.html',
    styles: []
})
export class AwardsComponent implements OnInit, OnDestroy {

    selectedStudentSubscription: Subscription;
    student360YearSubscription: Subscription;
    selectedStudent: Student;
    awards: Awards[] = [];

    // ------------Selection/Flags-----------------------------------
    isBusy = false;

    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    columnsToDisplay = ['AwardName', 'AwardDetails', 'AwardDate', 'StaffName', 'Comment'];
    clearFilterEvent = new EventEmitter<any>();

    constructor(
        private studentService: StudentService,
        private yearService: YearService,
        private awardsService: AwardsService,
        public changeDetector: ChangeDetectorRef
    ) {
        this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
            studentId => {
                this.loadStudentInfo(studentId);
            });

        this.angularMatData = new TylerMatTableDataSource(this.awards);

        this.student360YearSubscription = yearService.observableStudent360YearStream$.subscribe(
            studentYear => {
                this.getStudentAwards();
            }
        );
    }

    ngOnInit() {
        this.loadStudentInfo(this.studentService.selectedStudent.Id);
    }

    ngOnDestroy() {
    }

    // ------------ Awards Data ---------------------------
    loadStudentInfo(studentId: number) {
        this.selectedStudent = this.studentService.students.find(x => x.Id == studentId);
        this.getStudentAwards();
    }

    getStudentAwards() {
        this.isBusy = true;
        this.angularMatData.data = [];

        this.awardsService.getStudentAwards(this.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
            this.awards = data;
            this.loadStudentAwards();
        });
    }

    loadStudentAwards() {
        this.angularMatData.data = this.awards;
        setTimeout(() => {
            this.angularMatData.sort = this.sort;
        }, 0);
        this.isBusy = false;
    }

    // ------------Aria/Accessibility---------------------------
    getAriaRow(row: Awards): string {
        const colList: string[] = ['Award', 'Details', 'Date', 'StaffName', 'Comment'];
        const dataList: string[] = [
            row.AwardName,
            row.AwardDetails,
            row.AwardDate.toString(),
            row.StaffName,
            row.Comment
        ];

        return AriaDirective.concatAriaStrings(colList, dataList);
    }
}